export const spacingScale: Record<string, string> = {
  "0": "0px",
  "1": "2px",
  "2": "4px",
  "3": "8px",
  "4": "16px",
  "5": "32px",
  "6": "48px",
  "7": "64px",
  "8": "96px",
  "9": "128px",
  "10": "160px",
  "11": "192px",
  "12": "224px",
  "14": "256px",
  "16": "320px",
  "20": "384px",
  "24": "448px",
  "28": "512px",
  "32": "576px",
  px: "1px",
  "0.5": "2px",
  "1.5": "6px",
  "2.5": "10px",
  "3.5": "14px",
  auto: "auto",
  full: "100%",
  "1/2": "50%",
  "1/3": "33.333%",
  "2/3": "66.667%",
  "1/4": "25%",
  "3/4": "75%",
};
